// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faq[data-v-65e8a5f9]{display:flex;padding-bottom:1rem}.faq .side-column[data-v-65e8a5f9]{flex:0 0 8px;background-color:#ed1c2f}.faq .main-column[data-v-65e8a5f9]{flex:1;background-color:#f2f2f2;padding:2rem}.faq .main-column .question[data-v-65e8a5f9]{font-weight:700;margin-bottom:1.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
